import React from 'react';
import { Layout, Button, Result } from 'antd';
import { useNavigate } from 'react-router';

const { Header, Content, Footer } = Layout;

const NotFound: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Layout className="layout" style={{ minHeight: '100vh' }}>
      <Header style={{ background: '#fff', textAlign: 'center', padding: 0 }}>
        <h1>医生管理系统</h1>
      </Header>
      <Content style={{ padding: '0 50px' }}>
        <div style={{ 
          background: '#fff', 
          padding: 24, 
          marginTop: 24, 
          minHeight: 280, 
          display: 'flex', 
          justifyContent: 'center', 
          alignItems: 'center' 
        }}>
          <Result
            status="404"
            title="404"
            subTitle="抱歉，您访问的页面不存在"
            extra={
              <Button type="primary" onClick={() => navigate('/')}>
                返回首页
              </Button>
            }
          />
        </div>
      </Content>
      <Footer style={{ textAlign: 'center' }}>医生管理系统 ©{new Date().getFullYear()}</Footer>
    </Layout>
  );
};

export default NotFound;